import { createSlice } from "@reduxjs/toolkit";
export const initialState = {
    setBenchmarkMode: false,
    setFundTab: "Funds",
    setMarketsTab: "Standard",
    setPMIsMode: false
};
const slice = createSlice({
    initialState,
    name: "mainGridSettingsReducers",
    reducers: {
        setBenchmarkMode: (state, action) => {
            state.setBenchmarkMode = action.payload;
            state.setPMIsMode = false;
        },
        setFundTab: (state, action) => {
            state.setFundTab = action.payload;
        },
        setMarketsTab: (state, action) => {
            state.setMarketsTab = action.payload;
        },
        setPMIsMode: (state, action) => {
            state.setPMIsMode = action.payload;
            state.setBenchmarkMode = false;
        }
    }
});
export const mainGridSettingsReducers = slice.reducer;
export const { setBenchmarkMode, setFundTab, setPMIsMode, setMarketsTab } = slice.actions;
